import React, { useRef, useEffect } from 'react';

import { useLayoutContext } from '@ott/layout-context';

import { S3_IMAGES_URL } from '../../../../constants';

import { motion, useInView, useAnimation } from 'framer-motion';

type Props = { className?: string };

const OrbitSeven = ({ className }: Props) => {
  const ref = useRef(null);
  const inViewport = useInView(ref);
  const control = useAnimation();
  const { isDesktop } = useLayoutContext();

  const variants = {
    initial: isDesktop
      ? { opacity: 0, scale: 0 }
      : { opacity: 0, scale: 0, left: '50%', right: '50%', x: '-50%', y: '-8%' },
    animate: isDesktop
      ? {
          opacity: 0.7,
          scale: 1,
          transition: { duration: 2.28 },
        }
      : {
          opacity: 0.7,
          scale: 0.7,
          rotate: 15,
          transition: { duration: 2.28 },
        },
  };

  useEffect(() => {
    if (inViewport) {
      control.start('animate');
    }
  }, [control, inViewport, isDesktop]);

  return (
    <motion.svg
      ref={ref}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="2174"
      height="942"
      fill="none"
      variants={variants}
      initial="initial"
      animate={control}
    >
      <path
        id="orbitEight"
        stroke="url(#a)"
        strokeWidth="2"
        shapeRendering="geometricPrecision"
        d="M2168.52 761.168c-13.65 50.953-56.83 91.488-123.38 121.118-66.55 29.628-156.4 48.316-263.24 55.611-213.68 14.589-495.2-16.399-793.909-96.438S429.983 647.495 252.228 528.022C163.348 468.284 94.88 407.175 52.06 348.242 9.237 289.304-7.887 232.612 5.766 181.658 19.419 130.705 62.595 90.17 129.149 60.54c66.55-29.628 156.4-48.316 263.241-55.61 213.677-14.59 495.199 16.398 793.91 96.437 298.71 80.039 558.01 193.963 735.76 313.437 88.88 59.737 157.35 120.847 200.17 179.78 42.82 58.937 59.95 115.63 46.29 166.584Z"
      />
      <defs>
        <linearGradient
          id="a"
          x1="1968.43"
          x2="386.146"
          y1="53.701"
          y2="831.725"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EED7F1" />
          <stop offset=".085" stopColor="#FEFCFE" />
          <stop offset=".192" stopColor="#DBC1D4" />
          <stop offset=".285" stopColor="#6DD2E5" />
          <stop offset=".4" stopColor="#7BA0EB" />
          <stop offset=".51" stopColor="#BC86F6" />
          <stop offset=".632" stopColor="#DCC4F8" />
          <stop offset=".747" stopColor="#BFB5C6" />
          <stop offset=".87" stopColor="#F5F4F6" />
          <stop offset="1" stopColor="#D7CACE" />
        </linearGradient>
      </defs>
      <image
        href={`${S3_IMAGES_URL}planets_for_orbits/planet-8@2x.png`}
        width="50"
        height="50"
        x="500"
        y="650"
      >
        <mpath href="#orbitEight" />
      </image>
    </motion.svg>
  );
};

export default OrbitSeven;
